import axios from 'axios';

// export const HTTP = axios.create({
//   baseURL: process.env.VUE_APP_API_BASE_URL,
//   headers: {

//   }
// })

export function HTTP(token=null) {
  return axios.create({
      baseURL: process.env.VUE_APP_API_BASE_URL,
      headers: {
        'Authorization': (token) ? `Bearer ${token}`: '',
      },
    })
} 

export function HTTP2(token=null) {
  return axios.create({
      baseURL: process.env.VUE_APP_API_BASE_URL,
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    })
} 

export const AUTH = axios.create({
  baseURL: process.env.VUE_APP_AUTH_BASE_URL,
  headers: {
  }
})